import { getSubdomain } from "@/core/services/api.service";

export function getExpectedOrigin() {
  const currentLicenseId = getSubdomain(window.location.origin);
  const origin = process.env.VUE_APP_IFRAME_ORIGIN ?? "";

  return origin.replace("{{licenseId}}", currentLicenseId);
}

export function postRedirectMessage(route) {
  if (!route || typeof route !== "string") {
    return;
  }

  // Sanitize route - only allow alphanumeric, slash, dash, underscore
  const sanitizedRoute = route.replace(/[^a-zA-Z0-9/\-_]/g, "");
  if (!sanitizedRoute) {
    return;
  }

  const expectedOrigin = getExpectedOrigin();
  if (!expectedOrigin) {
    return;
  }

  const payload = {
    type: "redirect",
    route: sanitizedRoute
  };

  window.parent.postMessage(payload, expectedOrigin);
}

export function postModalMessage(modalState) {
  const expectedOrigin = getExpectedOrigin();
  if (!expectedOrigin) {
    return;
  }

  const payload = {
    type: modalState
  };

  window.parent.postMessage(payload, expectedOrigin);
}
